<template>
  <div class="poi__icon">
    <svg width="60" height="73" viewBox="0 0 60 73" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M48.9135 27.3358C47.8556 22.6374 45.5942 18.5814 42.1846 15.2106C38.3871 11.4551 33.8341 9.15279 28.5463 8.31169C23.8619 7.56599 19.3422 8.16541 15.0158 10.0336C10.0305 12.1849 6.13314 15.6399 3.39661 20.3621C0.428877 25.4851 -0.597322 30.9912 0.330689 36.8439C0.991065 41.016 2.67447 44.754 5.19087 48.1295C10.0004 54.5785 14.7988 61.0338 19.5956 67.4923C20.9528 69.3208 22.2894 71.1636 23.6371 73H25.8573C25.9523 72.8664 26.0505 72.7361 26.1503 72.6089C26.1693 72.5787 26.1899 72.55 26.2105 72.5214C31.0738 65.9818 35.9594 59.4581 40.7926 52.8963C42.769 50.214 44.8594 47.5778 46.4937 44.6904C49.5549 39.2845 50.2833 33.4222 48.9135 27.3358Z"
        fill="#2FE449"
      />
      <path
        d="M34.667 40.4766C34.5673 40.3208 34.4675 40.1666 34.3677 40.0107C34.3392 40.0648 34.3123 40.1189 34.2838 40.1745C33.9877 40.0616 33.6123 40.0282 33.4096 39.8231C31.3731 37.772 29.3634 35.6955 27.3522 33.6206C27.1004 33.3614 26.9025 33.2136 26.4717 33.309C25.6245 33.4966 25.0259 32.8622 24.4478 32.3931C23.3044 31.4646 22.2292 30.455 21.1016 29.4565C20.8926 30.4041 20.6693 31.4169 20.446 32.4281C20.3114 33.0403 20.115 33.6461 20.0659 34.2646C20.0406 34.573 20.2338 34.9339 20.4096 35.2185C21.0969 36.3268 21.9045 37.3682 22.4936 38.5241C22.907 39.335 23.0479 40.289 23.2949 41.1826C23.6481 42.4577 23.9917 43.7376 24.3354 45.016C24.6331 46.1258 24.1754 47.0655 23.1857 47.3024C22.2244 47.5329 21.1824 46.9033 20.9654 45.9604C20.5869 44.31 20.1467 42.666 19.5845 41.0697C19.1822 39.9281 18.5409 38.8707 18.0072 37.7768C17.9327 37.7943 17.8583 37.8134 17.7839 37.8309C17.7221 38.2443 17.5796 38.664 17.6129 39.0711C17.7316 40.5275 16.9588 41.7247 16.536 43.0222C16.2208 43.9936 15.8107 44.9333 15.4607 45.8937C14.9745 47.2308 13.8644 47.7078 12.702 47.0639C11.9941 46.6712 11.7138 45.8905 12.0385 45.0001C12.6339 43.3624 13.2895 41.7454 13.8818 40.1061C14.0528 39.6323 14.1384 39.1172 14.1859 38.6131C14.3015 37.3984 14.3743 36.1805 14.4567 34.9626C14.4646 34.8513 14.4598 34.7113 14.3997 34.6255C13.6934 33.5999 13.9895 32.549 14.2635 31.4726C14.52 30.4677 14.691 29.439 14.7702 28.326C14.0069 29.1385 13.2214 29.9303 12.4866 30.7682C12.0305 31.2881 11.6315 31.9177 10.8381 31.7428C10.4216 31.6522 9.94014 31.4153 9.69467 31.0878C9.33677 30.614 9.43654 30.0066 9.81978 29.5312C11.386 27.5866 13.0219 25.693 15.2675 24.5212C16.2984 23.9837 17.4592 23.6991 18.5124 23.3175C17.9153 22.8374 17.4086 22.0805 17.2233 21.1409C17.0364 20.1901 17.3136 19.314 17.8124 18.5317C18.5741 17.3345 20.6186 16.7811 21.9821 17.414C23.5309 18.1326 24.1802 19.5906 23.9759 21.0312C23.7083 22.9216 22.4825 23.8359 20.3747 23.9329C21.5355 25.3289 22.6615 26.8123 23.9284 28.1606C24.7535 29.0399 25.7765 29.7331 26.7267 30.4915C27.3174 30.9622 27.8115 31.4519 27.6753 32.3089C27.6547 32.4424 27.7893 32.6348 27.9017 32.7525C29.7609 34.6779 31.6233 36.6002 33.4967 38.5114C33.853 38.8739 34.26 39.1855 34.7304 39.5973C35.1722 38.7976 35.6536 37.9628 36.0971 37.1074C36.2602 36.791 36.3536 36.3411 36.7954 36.5176C37.0868 36.6336 37.4558 36.9866 37.4812 37.2617C37.5841 38.3699 38.3791 38.8834 39.1376 39.4495C39.2469 39.5322 39.391 39.5671 39.513 39.6339C39.9231 39.8549 40.2446 40.2158 40.0451 40.6531C39.893 40.9886 39.5003 41.2334 39.1741 41.4576C39.0442 41.5467 38.794 41.5164 38.6166 41.4703C38.0101 41.3129 37.4558 41.3781 36.9554 41.7756C36.1905 41.34 35.4288 40.9075 34.667 40.4766Z"
        fill="white"
      />
      <path
        d="M34.4628 40.7946C35.2245 41.2255 35.9878 41.658 36.7495 42.0888C36.7939 42.4577 36.8715 42.8266 36.8778 43.1971C36.8952 44.2671 36.8968 45.3388 36.8778 46.4088C36.8699 46.862 36.7479 47.2451 36.1509 47.2245C35.5681 47.2038 35.4525 46.8683 35.4684 46.377C35.4842 45.8332 35.4715 45.2895 35.4715 44.6964C34.3725 44.6964 33.3178 44.6964 32.1491 44.6964C32.3961 45.0939 32.621 45.4532 32.8443 45.8158C33.1578 46.3214 33.1119 46.943 32.7477 47.1545C32.3217 47.4025 31.8181 47.1641 31.5124 46.5837C31.2622 46.1099 30.9978 45.6456 30.6985 45.105C30.4229 45.6472 30.1774 46.1528 29.9098 46.6473C29.6786 47.075 29.3286 47.4169 28.8313 47.1529C28.3404 46.8922 28.4022 46.3977 28.6397 45.9779C29.2542 44.8936 29.6279 43.7806 29.5266 42.4927C29.4806 41.9187 29.2573 41.5737 28.8646 41.2541C28.7031 41.1221 28.5225 41.0108 28.3689 40.8709C28.0079 40.5434 28.0379 40.0728 28.3246 39.8374C28.5447 39.6562 29.2019 39.6164 29.3286 39.777C30.1949 40.882 31.3731 40.6388 32.507 40.6658C33.1578 40.6801 33.8103 40.7501 34.4628 40.7946Z"
        fill="white"
      />
      <circle cx="44" cy="16" r="16" fill="#FF2870" />
      <path
        d="M53.4117 16.5899C53.2889 17.2355 53.2235 17.8975 53.0435 18.5267C52.2989 21.1419 50.7033 23.095 48.2895 24.3372C45.7694 25.6366 43.1429 25.7592 40.5082 24.6968C38.0207 23.6998 36.2615 21.9182 35.2715 19.4338C34.3469 17.1129 34.3632 14.7756 35.3042 12.4629C36.1634 10.3463 37.6362 8.74448 39.6572 7.68208C41.8992 6.50527 44.2638 6.27645 46.6858 7.00378C49.2305 7.77198 51.1206 9.37375 52.3561 11.7192C52.9371 12.8143 53.2644 13.9829 53.3626 15.2169C53.3708 15.2823 53.3953 15.3559 53.4035 15.4212C53.4117 15.8135 53.4117 16.1976 53.4117 16.5899ZM45.573 14.4406C45.573 14.2935 45.573 14.1791 45.573 14.0728C45.573 13.1248 45.5894 12.1768 45.5648 11.2289C45.5403 10.3217 44.9021 9.73333 44.002 9.7415C43.0938 9.7415 42.4637 10.3381 42.4555 11.237C42.4392 12.847 42.4392 14.4569 42.4555 16.0669C42.4637 16.9413 43.0447 17.5379 43.912 17.5542C45.0248 17.5787 46.1376 17.5706 47.2504 17.5542C47.7577 17.546 48.1913 17.3417 48.4614 16.8923C48.7887 16.3447 48.805 15.7645 48.5186 15.2006C48.2486 14.6694 47.7659 14.4487 47.1849 14.4406C46.6531 14.4324 46.1376 14.4406 45.573 14.4406Z"
        fill="white"
      />
    </svg>
  </div>
  <p class="poi__type">{{ selectedEvent.location }}</p>
  <div class="scroll">
    <div class="poi__header">
      <div class="poi__header__button" @click="isEditor ? goToEdit() : goToDestination()">
        <svg
          width="28.15"
          height="28.15"
          viewBox="0 0 22 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          v-if="isEditor"
        >
          <path
            d="M2.19057 17.3411C2.19167 17.1585 2.22924 17.0454 2.29295 16.9391C2.70839 16.2468 3.12296 15.5538 3.5395 14.8621C3.56432 14.821 3.56388 14.7917 3.54257 14.7497C3.35056 14.3726 3.18908 13.9825 3.06166 13.5788C3.0476 13.5344 3.02629 13.5133 2.97972 13.5014C2.18222 13.3005 1.38539 13.0977 0.588556 12.8946C0.316794 12.8253 0.125439 12.5805 0.125 12.2982C0.123901 11.4499 0.123901 10.6016 0.125 9.75326C0.125439 9.47364 0.314377 9.22989 0.58548 9.16059C1.38034 8.95709 2.17563 8.7549 2.97115 8.5547C3.02343 8.5415 3.04782 8.51884 3.06386 8.4678C3.19084 8.06586 3.35188 7.67756 3.54323 7.30202C3.56366 7.26177 3.56432 7.23382 3.54082 7.19466C3.12647 6.50584 2.71367 5.81614 2.30042 5.12666C2.12269 4.82988 2.15806 4.53816 2.40236 4.29352C2.97972 3.71536 3.55685 3.1372 4.13421 2.55926C4.37566 2.31748 4.66917 2.28118 4.96202 2.45718C5.65055 2.87078 6.33929 3.2846 7.02715 3.6993C7.06516 3.72218 7.09394 3.72548 7.13502 3.70436C7.51641 3.50922 7.91143 3.34664 8.3194 3.21684C8.35807 3.20452 8.37366 3.18494 8.38245 3.1482C8.57754 2.33156 8.77373 1.51514 8.96948 0.698724C9.04154 0.398424 9.2966 0.195804 9.60571 0.195584C10.4401 0.195364 11.2747 0.195364 12.1091 0.195584C12.4161 0.195584 12.6702 0.395124 12.7425 0.694984C12.938 1.5059 13.1329 2.31704 13.3258 3.12862C13.3381 3.1801 13.359 3.20694 13.4106 3.223C13.8157 3.3506 14.2063 3.51428 14.5847 3.70722C14.6196 3.72504 14.6444 3.72394 14.678 3.7037C15.3677 3.28812 16.0579 2.87364 16.748 2.45916C17.045 2.28074 17.3357 2.31616 17.5798 2.56036C18.1584 3.13984 18.7369 3.7191 19.3156 4.29858C19.5542 4.5375 19.59 4.83164 19.4153 5.12292C19.0012 5.81394 18.5873 6.50518 18.1721 7.19554C18.1499 7.2325 18.149 7.26 18.1688 7.29873C18.3628 7.67888 18.5244 8.07268 18.6543 8.47946C18.6675 8.52061 18.6861 8.53996 18.7288 8.5503C19.5452 8.7494 20.3611 8.95048 21.1775 9.15047C21.4855 9.22592 21.6733 9.46331 21.6733 9.78187C21.6733 10.6121 21.6736 11.4424 21.6733 12.2725C21.6733 12.5884 21.4888 12.826 21.1819 12.9017C20.3672 13.1025 19.5524 13.3025 18.7373 13.5012C18.6897 13.5128 18.6664 13.5337 18.6514 13.5808C18.5227 13.988 18.3597 14.3812 18.1655 14.7613C18.1472 14.7972 18.1512 14.8223 18.1707 14.8548C18.5857 15.5454 18.9996 16.2367 19.4136 16.9277C19.5911 17.2238 19.5548 17.5162 19.3105 17.7606C18.7332 18.3388 18.156 18.9169 17.5787 19.4949C17.3372 19.7364 17.0444 19.7723 16.7509 19.5958C16.0606 19.1814 15.3703 18.7669 14.6809 18.3513C14.646 18.3302 14.6205 18.3278 14.5833 18.3467C14.2055 18.5405 13.8144 18.7031 13.4095 18.8311C13.3601 18.8467 13.3388 18.8718 13.3267 18.9211C13.1331 19.7065 12.938 20.4915 12.7425 21.2764C12.6676 21.5772 12.4156 21.7736 12.1074 21.7738C11.2747 21.7741 10.4419 21.7741 9.60923 21.7738C9.29836 21.7738 9.04483 21.5752 8.97014 21.274C8.77439 20.4855 8.57842 19.6968 8.38399 18.9081C8.3741 18.8683 8.35653 18.8487 8.3172 18.8362C7.90571 18.7048 7.50741 18.5409 7.12338 18.3432C7.08867 18.3253 7.06538 18.3324 7.03528 18.3504C6.34259 18.7675 5.64901 19.1836 4.95609 19.6007C4.76583 19.7153 4.56635 19.7426 4.36116 19.6539C4.28844 19.6225 4.21748 19.5745 4.16123 19.5186C3.56388 18.9248 2.96939 18.3282 2.37446 17.7318C2.25077 17.6084 2.19079 17.4577 2.19057 17.3411ZM10.8573 7.86742C9.11426 7.86676 7.70052 9.28203 7.70096 11.0264C7.7014 12.7723 9.11316 14.1865 10.8562 14.1871C12.5964 14.1878 14.0104 12.7745 14.0119 11.0328C14.0135 9.28246 12.6037 7.86786 10.8573 7.86742Z"
            :fill="'#C7C7C7'"
          />
        </svg>

        <svg width="26" height="35" viewBox="0 0 17 22" fill="none" xmlns="http://www.w3.org/2000/svg" v-else>
          <path
            d="M15.9611 0.000574592C16.197 0.159007 16.2195 0.373121 16.167 0.635453C15.6473 3.25189 15.1351 5.86947 14.6228 8.48705C14.5876 8.66558 14.53 8.82286 14.3402 8.88256C14.1516 8.94168 14.0091 8.85443 13.881 8.72126C13.3428 8.16387 12.8023 7.60936 12.2468 7.03705C12.1649 7.13004 12.1211 7.17424 12.0836 7.22303C10.3583 9.47725 9.27499 12.0041 8.88217 14.8106C8.77141 15.6016 8.72584 16.4058 8.71084 17.2054C8.68373 18.6227 8.70335 20.0406 8.70335 21.4579C8.70335 21.8878 8.58856 21.9997 8.14959 21.9997C6.97688 21.9997 5.80417 22.0003 4.63147 21.9997C4.25133 21.9997 4.12847 21.8769 4.12847 21.498C4.12789 19.9516 4.12847 18.4052 4.12847 16.8587C4.12847 13.5649 4.98911 10.4853 6.47676 7.56401C7.15166 6.23857 7.96846 5.00268 8.94735 3.81042C8.7893 3.66749 8.62663 3.52914 8.47434 3.38104C8.12882 3.04638 7.79079 2.70484 7.44527 2.37018C7.31664 2.24561 7.24165 2.10727 7.29644 1.92989C7.34894 1.76055 7.48392 1.69224 7.6512 1.65838C9.66435 1.25024 11.6769 0.839234 13.6895 0.428801C14.3229 0.299644 14.9562 0.169913 15.589 0.0396083C15.6144 0.034442 15.6363 0.0137767 15.66 0C15.7592 0.000574031 15.8601 0.000574592 15.9611 0.000574592Z"
            fill="#C7C7C7"
          />
          <path
            d="M3.50203 13.104C3.18361 12.1448 2.88885 11.189 2.54967 10.2493C2.05071 8.86821 1.42484 7.54219 0.712452 6.25637C0.531903 5.93032 0.558438 5.80747 0.855508 5.58475C1.88343 4.8144 2.91192 4.04405 3.941 3.27485C4.20749 3.07566 4.41977 3.09575 4.59571 3.3753C5.12524 4.21741 5.63805 5.06984 6.16239 5.91539C6.24488 6.04857 6.23392 6.15247 6.15547 6.28564C5.08544 8.10245 4.26633 10.0237 3.7443 12.0673C3.65662 12.4123 3.58221 12.7613 3.50203 13.104Z"
            fill="#C7C7C7"
          />
        </svg>
      </div>

      <div class="poi__header__content">
        <h1 class="poi__name">{{ selectedEvent.name }}</h1>
        <p class="poi__date">{{ dateString }}</p>
        <div class="poi__time">{{ hourString }}</div>
      </div>

      <div class="poi__header__button" @click="handleVisit">
        <lottie-animation
          v-if="!isVisitor"
          ref="anim"
          :autoPlay="false"
          :playInterval="10000"
          :playOnClick="true"
          :animationData="require(`@/assets/images/lottie/events/accept-inactive.json`)"
        />

        <lottie-animation
          v-else
          ref="anim"
          :autoPlay="false"
          :playInterval="10000"
          :playOnClick="true"
          :animationData="require(`@/assets/images/lottie/events/accept-active.json`)"
        />
      </div>
    </div>

    <div class="poi__pet__list" v-if="selectedEvent.pets?.length">
      <h1 class="title">Szervezők:</h1>
      <div class="poi__pet__list__list">
        <div
          class="poi__pet__list__list__item"
          v-for="pet in selectedEvent.pets"
          :key="pet.id"
          @click="goToPet(pet.id)"
        >
          <ion-img :src="pet.avatar" />
        </div>
      </div>
    </div>

    <div class="poi__pet__list" v-if="selectedEvent.visitors?.length">
      <h1 class="title">Résztvevők:</h1>
      <div class="poi__pet__list__list">
        <div
          class="poi__pet__list__list__item"
          v-for="pet in selectedEvent.visitors"
          :key="pet.id"
          @click="goToPet(pet.id)"
        >
          <ion-img :src="pet.avatar" />
        </div>
      </div>
    </div>

    <div class="poi__about" v-if="selectedEvent.description">
      <h1 class="title">Az eseményről:</h1>
      <p>{{ selectedEvent.description }}</p>
    </div>

    <div class="poi__images" v-if="selectedEvent.images?.length">
      <h1 class="title">A Szervezők képei:</h1>
      <div class="poi__images__list">
        <div
          class="poi__images__list__item"
          v-for="image in selectedEvent.images"
          :key="image.id"
          :style="`background-image: url(${image.url});`"
          @click="openImage(image.url)"
        ></div>
      </div>
    </div>

    <div class="poi__about">
      <div class="message-box">
        <ion-img
          :src="
            activePet?.avatar ??
            'https://res.cloudinary.com/doxocial/image/upload/w_280,h_280,c_fill/dfr2o6kimwlrs26sbm8t.png'
          "
        />

        <div class="input" @click="goToChat">
          hozzászólás az eseményhez

          <div class="icons">
            <svg xmlns="http://www.w3.org/2000/svg" width="23" height="21" viewBox="0 0 23 21" fill="none">
              <path
                d="M5.96527 16.7049C4.43716 16.7049 3.07789 15.7264 2.58431 14.2698L2.55092 14.16C2.43452 13.7743 2.38575 13.4499 2.38575 13.1253V6.61719L0.0700788 14.3471C-0.227748 15.484 0.450927 16.6627 1.58963 16.9768L16.3497 20.9297C16.5339 20.9774 16.7182 21.0003 16.8996 21.0003C17.8502 21.0003 18.7189 20.3693 18.9623 19.4395L19.8223 16.7049H5.96527Z"
                fill="#EBEBEB"
              />
              <path
                d="M8.59029 6.68155C9.64317 6.68155 10.4992 5.8253 10.4992 4.77242C10.4992 3.71953 9.64317 2.86328 8.59029 2.86328C7.53741 2.86328 6.68115 3.71953 6.68115 4.77242C6.68115 5.8253 7.53741 6.68155 8.59029 6.68155Z"
                fill="#EBEBEB"
              />
              <path
                d="M20.5222 0H6.20416C4.88893 0 3.81787 1.07106 3.81787 2.38646V12.8863C3.81787 14.2017 4.88893 15.2727 6.20416 15.2727H20.5222C21.8376 15.2727 22.9087 14.2017 22.9087 12.8863V2.38646C22.9087 1.07106 21.8376 0 20.5222 0ZM6.20416 1.90913H20.5222C20.7858 1.90913 20.9996 2.12289 20.9996 2.38646V9.16273L17.9842 5.64421C17.6644 5.26913 17.2014 5.06865 16.7041 5.05729C16.2097 5.06009 15.7458 5.27961 15.4289 5.65959L11.8837 9.91481L10.7287 8.76265C10.0759 8.10984 9.01342 8.10984 8.36148 8.76265L5.72701 11.3963V2.38646C5.72701 2.12289 5.94076 1.90913 6.20416 1.90913Z"
                fill="#EBEBEB"
              />
            </svg>

            <svg xmlns="http://www.w3.org/2000/svg" width="22" height="21" viewBox="0 0 22 21" fill="none">
              <path
                d="M6.32047 11.6287C7.33792 11.6287 8.36274 11.636 9.38019 11.6287C10.1986 11.6214 10.6557 11.1085 10.5746 10.3025C10.5156 9.73837 10.1175 9.33539 9.54976 9.31341C9.06316 9.29142 8.57655 9.30608 8.08994 9.30608C6.46792 9.30608 4.85328 9.29875 3.23126 9.31341C3.01744 9.31341 2.91422 9.25479 2.82575 9.04964C1.99999 7.08603 1.16687 5.12975 0.326365 3.17347C-0.0275305 2.35285 0.0535706 1.5762 0.599159 0.872821C1.15212 0.162112 1.91889 -0.0943295 2.80363 0.0302278C3.11329 0.0741892 3.43032 0.184093 3.71049 0.323304C9.39493 3.00495 15.072 5.69392 20.7491 8.38289C21.5306 8.74923 21.9214 9.38667 21.9877 10.2219C22.0614 11.1085 21.8108 11.8778 21.0366 12.3907C20.7048 12.6105 20.3215 12.7644 19.9528 12.9329C14.4896 15.4753 9.01892 18.0251 3.54829 20.5822C3.48193 20.6115 3.41558 20.6408 3.35659 20.6847C2.47186 21.2709 1.44703 20.9485 0.849835 20.4576C0.119926 19.8568 -0.204478 18.8897 0.134671 18.0471C0.621278 16.8235 1.17424 15.6292 1.70508 14.4276C2.0811 13.5777 2.47186 12.7277 2.8405 11.8705C2.9216 11.6873 3.01744 11.636 3.20914 11.636C4.24133 11.636 5.2809 11.6287 6.32047 11.6287Z"
                fill="#EBEBEB"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>

    <div class="poi__about" style="margin-bottom: 50px" v-if="comments.length" :key="comments">
      <h1 style="text-align: center; margin: 36px 0 20px 0">Beszélgetések:</h1>

      <Chat :comments="comments" :key="comments" />
    </div>

    <div class="share-box" @click="shareToSocial">
      <ion-button type="submit" id="submit" expand="full" shape="round" strong="true" class="btn submit">
        Esemény&nbsp; megosztása
      </ion-button>
    </div>

    <h1 class="poi__report" @click="confirmPostReport">Valami nincs rendben, jelentem.</h1>
  </div>
</template>
<script>
import { alertController, isPlatform, popoverController } from '@ionic/core'
import { defineComponent, toRefs, ref, watch, onMounted, computed } from 'vue'
import { IonImg, IonButton } from '@ionic/vue'
import Chat from './Event/Chat'

import useAuth from '@/composables/auth'
import usePets from '@/composables/pets'
import useToast from '@/composables/toast'
import usePois from '@/composables/pois'
import useEvents from '@/composables/events'
import useNavigation from '@/composables/navigation'

import { PET_ROUTE, PAGE_EVENT_CHAT_ROUTE, PAGE_EVENT_EDIT_ROUTE, LOGIN_ROUTE } from '@/constants/routes'
import { useRoute, useRouter } from 'vue-router'
import { Share } from '@capacitor/share'

export default defineComponent({
  name: 'EventDetails',
  props: {
    selectedEvent: {},
  },
  components: {
    IonImg,
    IonButton,
    Chat,
  },
  setup(props) {
    const route = useRoute()
    const router = useRouter()
    const { isAuthenticated } = useAuth()
    const { activePet } = usePets()
    const { openToast } = useToast()
    const { navigateTo } = useNavigation()
    const { getEvent, visitEvent } = useEvents()
    const { reportPoi } = usePois()
    const selectedEvent = toRefs(props).selectedEvent
    const alreadyReported = ref(false)
    const isEditor = computed(
      () => selectedEvent.value?.editors.find(pet => activePet.value?.id === pet.pet_id) !== undefined,
    )
    const dateString = ref('')
    const hourString = ref('')
    const isVisitor = ref(selectedEvent.value?.visitors.find(pet => activePet.value?.id === pet.id) !== undefined)
    const comments = ref(selectedEvent.value.comments ?? [])

    const dayNames = ['Vasárnap', 'Hétfő', 'Kedd', 'Szerda', 'Csütörtök', 'Péntek', 'Szombat']
    const monthNames = [
      'január',
      'február',
      'március',
      'április',
      'május',
      'június',
      'július',
      'augusztus',
      'szeptember',
      'október',
      'november',
      'december',
    ]

    const getEventDetails = async () => {
      const event = await getEvent(selectedEvent.value.id)
      selectedEvent.value = event
      comments.value = event.comments
    }

    const goToDestination = () => {
      const destination = selectedEvent.value.latitude + ', ' + selectedEvent.value.longitude

      if (isPlatform('ios')) {
        window.open(`maps://?q=${destination}`, '_system')
      } else {
        window.open(`geo:0,0://?q=${destination}`, '_system')
      }
    }

    const handleVisit = async () => {
      if (!isAuthenticated.value) return

      try {
        await visitEvent(selectedEvent.value.id)

        if (!isVisitor.value) {
          isVisitor.value = true
          selectedEvent.value.visitors?.push({
            id: activePet.value.id,
            avatar: activePet.value.avatar,
          })
        } else {
          isVisitor.value = false
          selectedEvent.value.visitors = selectedEvent.value.visitors?.filter(p => p.id !== activePet.value.id) ?? []
        }
      } catch {
        // do nothing
      }
    }

    const confirmPostReport = async () => {
      if (!isAuthenticated.value) return

      const dialog = await alertController.create({
        cssClass: 'confirm-dialog',
        message: `<img src="${require('@/assets/images/icons/exclamation-circle.svg')}" class="alert-icon" /><p class="ion-text-center">Kifogásolható tartalommal találkoztál? Jelentsd nekünk és megvizsgáljuk az esetet!</p>`,
        buttons: [
          {
            text: 'Tartalom jelentése',
            cssClass: 'btn btn-dark btn-block',
            handler: async () => {
              try {
                await popoverController.dismiss()
                await reportToAdmins()

                return Promise.resolve()
              } catch (error) {
                return Promise.reject(error)
              }
            },
          },
          {
            text: 'Mégse',
            role: 'cancel',
            cssClass: 'btn btn-link btn-block',
          },
        ],
      })

      return dialog.present()
    }

    const reportToAdmins = async () => {
      if (alreadyReported.value) {
        return
      }

      alreadyReported.value = true

      try {
        await reportPoi(selectedEvent.value.id)

        openToast({
          message: 'Sikeresen jelentetted ezt a helyet. Hamarosan átvizsgáljuk.',
          color: 'success',
        })
      } catch (error) {
        console.error(error)
        alreadyReported.value = false

        openToast({
          message: 'Sajnos nem sikerült jelenteni ezt a helyet :(',
          color: 'warning',
        })
      }
    }

    const goToChat = async () => {
      if (!isAuthenticated.value) {
        return navigateTo({ name: LOGIN_ROUTE })
      }

      await navigateTo({ name: PAGE_EVENT_CHAT_ROUTE, params: { id: selectedEvent.value.id } })
    }

    const goToEdit = async () => {
      await navigateTo({ name: PAGE_EVENT_EDIT_ROUTE, params: { id: selectedEvent.value.id } })
    }

    const openImage = async url => {
      const dialog = await alertController.create({
        cssClass: 'poi-image-dialog',
        message: `<img src="${url}" class="poi-image-alert" />`,
      })

      await dialog.present()
    }

    const goToPet = async petId => {
      await router.push({ name: PET_ROUTE, params: { id: petId } })
    }

    const shareToSocial = async () => {
      try {
        await Share.share({
          url: `https://doxocial.com/event/${selectedEvent.value.slug}`,
        })
      } catch {}
    }

    watch(
      () => route.name,
      () => getEventDetails(),
    )

    onMounted(() => {
      const date = new Date(selectedEvent.value.date)

      dateString.value = `${monthNames[date.getMonth()]} ${date.getDate()}. ${dayNames[date.getDay()]}`
      hourString.value = `${date.getHours() < 10 ? '0' + date.getHours() : date.getHours()}:${
        date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
      }`
    })

    return {
      comments,
      activePet,
      isEditor,
      dateString,
      hourString,
      isVisitor,
      goToChat,
      goToEdit,
      goToDestination,
      handleVisit,
      confirmPostReport,
      openImage,
      goToPet,
      shareToSocial,
      isAuthenticated,
    }
  },
})
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@900&family=Poppins:wght@800&display=swap');

.company-like {
  #company-like {
    fill: #dcdcdc;
    transition: 0.15s ease-in-out;
  }

  &.liked #company-like,
  &:hover #company-like {
    fill: #e6224a;
    transition: 0.15s ease-in-out;
  }
}

.scroll {
  overflow-y: auto;
  max-height: calc(100vh - 250px);
  padding-bottom: 110px;
}

h1 {
  font-weight: 700;
  font-size: 12px !important;
  text-align: left;
  margin: 0 26px 5px 26px;

  &.title {
    padding: 0 16px;
  }
}

.poi {
  &__icon {
    position: relative;
    top: -65px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 6;
    min-width: 75px;
    max-width: 75px;
    min-height: 75px;
    max-height: 75px;
    background: #fff;
    border-radius: 50%;

    display: flex;
    justify-content: center;
    align-items: center;

    .lottie-animation {
      max-width: 50px;
    }

    svg {
      max-height: 50px;
    }
  }

  &__type {
    margin-top: -65px;
    font-size: 10px;
    color: #a6a6a6;
    position: relative;

    &:after {
      top: 20px;
      left: 0;
      position: absolute;
      width: 100%;
      height: 30px;
      content: '';
      z-index: 1;
      pointer-events: none;
      background: linear-gradient(white 0%, white 20%, transparent 100%);
    }
  }

  &__name {
    margin-top: 30px;
    font-weight: 900;
    text-align: center;
    font-size: 16px !important;
    letter-spacing: -0.3px;
    font-family: 'Montserrat', sans-serif;
    margin: 15px 10px 2px;
  }

  &__date {
    margin-top: -2px;
    color: #10ce2c;
    font-family: 'Open Sans', sans-serif;
    font-weight: bold;
    font-size: 12px;
    letter-spacing: -0.3px;
  }

  &__time {
    margin-top: -11px;
    color: #222;
    font-family: 'Montserrat', sans-serif;
    font-weight: 900;
    font-size: 18px;
    letter-spacing: -0.3px;
  }

  &__header {
    display: flex;
    align-items: center;
    padding: 0 26px;
    margin-bottom: 34px;

    &__button {
      min-width: 60px;
      min-height: 60px;
      max-width: fit-content;
      border-radius: 9999px;

      display: flex;

      align-items: center;
      justify-content: center;

      box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.15);

      .lottie-animation {
        width: 44px;
        height: 44px;
      }
    }

    &__content {
      flex-grow: 1;

      &__rating {
        display: flex;
        justify-content: center;

        ion-img {
          margin: 0 1.5px;
          min-width: 14px;
        }

        &__title {
          font-size: 10px;
          font-weight: 400;
        }
      }
    }
  }

  &__images {
    &__list {
      display: flex;
      overflow-x: auto;
      white-space: nowrap;
      padding: 0 26px 27px 26px;

      &__item {
        min-width: 140px;
        aspect-ratio: 1 / 1;

        background-position: center center;
        background-size: cover;
        border-radius: 25px;
        box-shadow: -7px 11px 29px -10px rgba(0, 0, 0, 0.2);

        margin-right: 16px;

        &:last-of-type {
          margin-right: 0;
        }
      }
    }
  }

  &__about {
    text-align: left;
    padding: 0 26px;
    margin-bottom: 35px;

    h1 {
      font-weight: 700;
      font-size: 12px !important;
      text-align: left;
      margin: 0 0 5px 0;
    }

    p {
      margin: 0;
      font-size: 12px;
    }
  }

  &__pet__list {
    margin-bottom: 15px;
    padding: 0 26px;

    &:nth-of-type(3) {
      margin-bottom: 30px;
    }

    h1 {
      margin: 0 0 5px 0;
    }

    &__list {
      display: flex;
      flex-direction: row-reverse;
      justify-content: flex-end;
      padding-left: 10px;

      &__item {
        min-width: 52px;
        min-height: 52px;
        max-width: 52px;
        max-height: 52px;
        border-radius: 9999px;
        margin-left: -10px;

        border: 5px solid #fff;
        filter: drop-shadow(-3px 5px 11px rgba(0, 0, 0, 0.15));

        ion-img::part(image) {
          border-radius: 9999px;
        }
      }
    }
  }

  &__report {
    margin-top: 22px;
    margin-bottom: 30px;
    color: #c8c8c8;
    text-align: center;
  }
}

.message-box {
  display: flex;
  align-items: center;
  margin-top: 20px;

  ion-img {
    width: 50px;
    height: 50px;
    min-width: 50px;
    min-height: 50px;
    border: 4px solid white;
    margin-right: 10px;
    border-radius: 99999px;
    filter: drop-shadow(-3px 5px 11px rgba(0, 0, 0, 0.15));

    &::part(image) {
      border-radius: 99999px;
    }
  }

  .input {
    color: #afafaf;
    box-shadow: -7px 11px 29px -10px rgba(0, 0, 0, 0.2);
    border-radius: 30px;
    font-weight: 400;
    height: 42px;
    font-size: 14px;
    background: #fff;
    padding: 10px 80px 10px 16px;
    position: relative;
    width: 100%;

    .icons {
      position: absolute;
      top: 50%;
      right: 12px;
      transform: translateY(-50%);
      display: flex;
      align-items: center;

      svg {
        height: 21px;
        margin-left: 15px;

        &:first-of-type {
          margin-left: 0;
        }
      }
    }
  }
}

.share-box {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 40px;
  margin-bottom: 50px;

  p {
    margin: 0;
    font-size: 14px;
    font-weight: bold;
    letter-spacing: -0.3px;
    line-height: 19px;
    color: #e6224a;
    margin-right: 7px;
  }
}

.submit {
  --background: #333;
  --box-shadow: none;
  height: 50px;
  max-width: 274px;
  margin: 0 auto;
  font-size: 16px;
  letter-spacing: -0.64px;
  font-weight: 900;
}
</style>
